
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.334 16a1.334 1.334 0 01-.943-2.277L13.73.383a1.334 1.334 0 011.887 1.886L2.277 15.609a1.33 1.33 0 01-.943.391z"}}),_c('path',{attrs:{"d":"M14.666 16a1.33 1.33 0 01-.943-.39L.383 2.268A1.334 1.334 0 012.268.382l13.34 13.34A1.334 1.334 0 0114.666 16z"}})])
          )
        }
      }
    